import {
  BlurIcon,
  CheckMarkSimpleIcon,
  CsvIcon,
  ExcelIcon,
  MongodbIcon,
  MysqlIcon,
  OracleIcon,
  PostgresqlIcon,
  SageIcon,
  SapIcon,
  SqlServerIcon,
} from "@dataone/icons";
import {
  DatabaseType,
  FileType,
  IDataSource,
  IPageableResponse,
} from "@dataone/lib";
import { styled } from "styled-components";

interface DatabaseListHeadProps {
  selectedDB: IDataSource | null;
  // selectedDataSourceType: IDataSource | null;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  datasources: IPageableResponse<Required<IDataSource>> | undefined;
}

const DatabaseListHead = ({
  selectedDB,
  setModalOpen,
  isModalOpen,
  datasources,
}: DatabaseListHeadProps) => {
  return (
    <StyledDatabaseListHead>
      {selectedDB ? (
        <StyledSentence>
          <StyledIcon>
            {selectedDB.internalType === DatabaseType.MYSQL ? (
              <MysqlIcon />
            ) : selectedDB.internalType === DatabaseType.SQLSERVER ? (
              <SqlServerIcon />
            ) : selectedDB.internalType === DatabaseType.SAGE ? (
              <SageIcon />
            ) : selectedDB.internalType === DatabaseType.POSTGRESQL ? (
              <PostgresqlIcon />
            ) : selectedDB.internalType === DatabaseType.SAP ? (
              <SapIcon />
            ) : selectedDB.internalType === FileType.EXCEL ? (
              <ExcelIcon />
            ) : (
              <CsvIcon />
            )}
          </StyledIcon>
          <span>{selectedDB.displayName}</span> is Selected
        </StyledSentence>
      ) : (
        ""
      )}
    </StyledDatabaseListHead>
  );
};

export default DatabaseListHead;

const StyledDatabaseListHead = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const StyledSentence = styled.div`
  display: flex;
  color: #040726;
  font-size: 13px;
  font-weight: 400;
  margin-left: 10px;
  align-items: center;
  span {
    font-size: 13px;
    font-weight: 700;
    margin-left: 10px;
    margin-right: 4px;
  }
`;

const StyledIcon = styled.div`
  display: flex;
  font-size: 20px;
`;
